import React from 'react';
import '../../../../assets/scss/components/videoVerification/VideoVerification.scss';
import VideoPlayerIpv from './VideoPlayerIpv';
import Backdrop from '../../../generic/Backdrop';
import ipvDemo from '../../../../assets/images/ipv_demo.jpg';
// import { AGetIpvOtp, AUploadIpv, AUploadIpvSafari } from '../Services/dashboard/ipvApiServices';
import { useHistory } from 'react-router-dom';
import ErrMsg from './ErrMsg';
import browserName from '../../../utils/browserName';
import {
    getIPVOTP
  } from "../../../service/generic/otherApi";
import useGeoLocation from '../../../utils/useGeoLocation';
import { geoLocationConfig } from '../constant';
import InfoModal from '../../../generic/InfoModal';
import DeviceContext from '../../../service/indentifyDevice';
import EdButton from '../../../generic/edButton';
  export interface iGeoLocation {
    loaded: boolean;
    coordinates: { lat: string; lng: string };
    error: boolean;
  }
  

export interface VideoVerificationProps {
    setVideoContent: (uploadObj: any) => any,
    setIpvcode: (otp: any) => any,
}

const VideoVerification: React.FC<VideoVerificationProps> = (props) => {
    // Fetch query params for clervertap
    //const quryParams = useQuery();

    const [errCode, setErrCode] = React.useState<number | string>();
    const [isLoading, setIsLoading] = React.useState<boolean>(false);
    const [showSample, setShowSample] = React.useState(false);
    const [otp, setOtp] = React.useState<string>('');
    const geoLoc: iGeoLocation = useGeoLocation();
    const [isGeoError, setIsGeoError] = React.useState<boolean>(false);
    const [isGeoErrorTimeFlag, setIsGeoErrorTimeFlag] = React.useState<boolean>(false);
    const [lat, setLat] = React.useState("");
    const [long, setLong] = React.useState("");
    const [browserPermission, setBrowserPermission] = React.useState<boolean>(true);
    const [locationPermission, setLocationPermission] = React.useState<boolean>(true);
    const [cameraPermission, setCameraPermission] = React.useState<boolean>(true);
    const [showBrowserPermissionModal, setsShowBrowserPermissionModal] = React.useState<boolean>(false);
 
    const history = useHistory();
    let watchPositionId: number;

    React.useEffect(() => {
       // window.sessionStorage.setItem('stageInfoId', '7');
       setTimeout(() => {
        watchPositionId = navigator.geolocation.watchPosition(
          successPosition,
          errorPosition
        );
        setIsGeoErrorTimeFlag(true);
      }, geoLocationConfig.errorTimer);
        setIsLoading(true);
        getIpvOtp();
       // AGetIpvOtp(getIpvOtp, GlobalStore.applicationID);
    }, []);

    React.useEffect(() => {
        watchPositionId = navigator.geolocation.watchPosition(
          successPosition,
          errorPosition
        );
        if (locationPermission === true && cameraPermission === true) {
          setBrowserPermission(true);
          setsShowBrowserPermissionModal(false);
          setIsGeoError(false);
        } else {
          setBrowserPermission(false);
          setsShowBrowserPermissionModal(true);
          setIsGeoError(true);
        }
        // getLocation();
      }, [geoLoc, locationPermission, cameraPermission]);

    async function getIpvOtp() {
        let generatedOtp = await getIPVOTP();
        if (!generatedOtp || generatedOtp.error) {
            setErrCode(456)
        } else {
            if (generatedOtp && generatedOtp.otp) {
                setOtp(generatedOtp.otp);
                getLocation();
            }
        }
        setIsLoading(false);
    }
    function errorPosition(data: any) {
        setIsLoading(true);
        setLocationPermission(false);
        // setBrowserPermission(false);
        // setsShowBrowserPermissionModal(true);
        // if (!browserPermission) {
        //   getLocation();
        // }
      }
    function successPosition(data: any) {
        setIsLoading(false);
        setLocationPermission(true);
        // setBrowserPermission(true);
        // setsShowBrowserPermissionModal(false);
        setLat(data.coords.latitude);
        setLong(data.coords.longitude);
        navigator.geolocation.clearWatch(watchPositionId);
      }
      const setLocation = (position: { coords: any }) => {
        console.log("Set Location", position.coords);
        setLat(position.coords.latitude);
        setLong(position.coords.longitude);
    
        geoLoc.coordinates.lat = position.coords.latitude;
        geoLoc.coordinates.lng = position.coords.longitude;
        geoLoc.error = false;
        setIsGeoError(false);
        setIsGeoErrorTimeFlag(false);
        setIsLoading(false);
        console.log("In saveLocation", geoLoc);
      };
    
      const errorLocation = (err: any) => {
        console.log(`ERROR(${err.code}): ${err.message}`);
        geoLoc.error = true;
        setIsLoading(true);
        setIsGeoError(true);
        // getLocation();
      };
    
      const getLocation = () => {
        if (geoLoc.loaded && geoLoc.error == false) {
          setLat(`${geoLoc.coordinates.lat}`);
          setLong(`${geoLoc.coordinates.lng}`);
        } else {
          if (navigator && navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(setLocation, errorLocation, {
              enableHighAccuracy: geoLocationConfig.enableHighAccuracy,
              maximumAge: geoLocationConfig.maximumAge,
              timeout: geoLocationConfig.timeout,
            });
            watchPositionId = navigator.geolocation.watchPosition(
              successPosition,
              errorPosition
            );
          }
        }
      };
    async function turnOnCamera() {
        getLocation();
    
        const constraints = {
          audio: false,
          video: {
            facingMode: "user",
          },
        };
    
        function handleSuccess(turnOfCamera: MediaStream) {
          console.log("HANDLE success", turnOfCamera);
          // setBrowserPermission(true);
          // setsShowBrowserPermissionModal(false);
          setCameraPermission(true);
          setIsLoading(false);
        }
    
        function handleError(error: any) {
          console.log("HANDLE ERROR", error);
          setIsLoading(true);
          // setBrowserPermission(false);
          // setsShowBrowserPermissionModal(true);
          setCameraPermission(false);
          console.log("handle error line end");
          // if (!browserPermission) {
          //   turnOnCamera();
          // }
        }
    
        navigator.mediaDevices
          .getUserMedia(constraints)
          .then((stream) => {
            console.log(stream, "then");
            handleSuccess(stream);
          })
          .catch((stream) => {
            console.log(stream, "catch");
            handleError(stream);
          });
    } 

    function ipvUploaded(uploadObj: any) {
        setIsLoading(true);
        props.setIpvcode(otp)
        props.setVideoContent(uploadObj);
        localStorage.setItem("ipvcode",otp);
        localStorage.setItem("imageData",uploadObj)
        if (lat !== "" && long !== undefined && long !== "" && long !== undefined) {
           localStorage.setItem("longitude", long);
           localStorage.setItem("latitude", lat);
        }
    }

    return (
        <>
        <div className="mgt40">
        <div className="fieldLblRight">
          <div className="explain">
            {showBrowserPermissionModal && (
              <div
                style={{
                  justifyContent: "center",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <InfoModal width={DeviceContext().isMobile ? "328px" : "354px"}>
                  <div className="explainInfo w-100">
                    <label>
                    To continue, we would mandatorily need access to your geo location and camera. 
                    Please click 'Allow' in your browser's notification
                    </label>
                  </div>
                  <div>
                    <EdButton
                      className="ed_button button submit_btn primary_border infoBtn"
                        onClick={() => turnOnCamera()}
                        value="OK"
                        btnTyp="primary"
                    >
                      OK
                    </EdButton>
                  </div>
                </InfoModal>
              </div>
            )}
          </div>
        </div>
      </div>
            <Backdrop isCloseIcon={true} isShow={showSample} onClose={() => setShowSample(false)}>
                <div className='ipvDemo'>
                    <img className='ipvDemoImg' src={ipvDemo} alt='ipvDemo' />
                    <div className='ipvDemoInfo'>
                        <label className='heading'>Video Verification</label>
                        <label className='info'>Write down the OTP on a white paper and hold it in front of the camera.</label>
                    </div>
                </div>
            </Backdrop>
            <fieldset disabled={isLoading}>
                <div className={'ipvHome' + (isLoading ? ' op05' : '')}>
                    <label className='ipvHeading'>Video Verification</label>
                    <label className='ipvInfo'>Write down the OTP given below on a white paper and hold it in front of the camera.</label>
                    <label className='ipvSample' onClick={() => setShowSample(true)}>View Sample</label>
                    <div className='ipvOtp'>
                        <label className='ipvOtpVal'>
                            {otp}
                        </label>
                    </div>
                    {
                        //otp &&
                        <div className='ipvVideoPlayer'>
                            <VideoPlayerIpv 
                                ipvUploaded={ipvUploaded}
                                isGeoError={showBrowserPermissionModal} />
                        </div>
                    }
                     {isGeoError && !isGeoErrorTimeFlag ? (
                        <>
                          <div className="geoErrorMsg">
                            <p>
                             {" "}
                             Please enable the camera and location to proceed further!
                            </p>
                          </div>
                        </>
                      ) : null}
                    {isGeoError && isGeoErrorTimeFlag ? (
                        <>
                          <div className="geoErrorMsg">
                            <p>
                             {" "}
                             Please enable the camera and location to proceed further!{" "}
                            </p>
                          </div>
                        </>
                      ) : null}
                    {/* Error Msg Start*/}
                    {
                        errCode &&
                        <div className='errMsgBlck'>
                            <ErrMsg>
                                {(typeof errCode === 'number') ?
                                    <>
                                        <label>We are facing some technical issue.</label>
                                        <label>Please try after sometime (error code:{errCode})</label>
                                    </>
                                    :
                                    <label>{errCode}</label>
                                }
                            </ErrMsg>
                        </div>
                    }
                    {/* Error Msg End*/}
                </div>
            </fieldset>
        </>
    );
}

export default VideoVerification;